<template>
  <div class="bar-chart-scroll">
    <div class="bar-chart-container">
      <canvas ref="canvas"></canvas>
    </div>
  </div>
</template>
<script>
import { Bar } from 'vue-chartjs';

export default {
  extends: Bar,
  name: 'ClosingReasonsBarChart',
  props: {
    reasonsData: {
      type: Array,
      required: true,
    },
  },
  methods: {
    updateChart() {
      const countsByDate = {};

      this.reasonsData.forEach(entry => {
        const date = new Date(entry.created_at).toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: 'short',
        });

        countsByDate[date] = (countsByDate[date] || 0) + 1;
      });

      const labels = Object.keys(countsByDate);
      const data = Object.values(countsByDate);

      const chartData = {
        labels,
        datasets: [
          {
            label: this.$t('CLOSING_REASONS.CHART.TOTAL_CLOSINGS'),
            backgroundColor: '#007bff',
            data,
          },
        ],
      };

      const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{ ticks: { autoSkip: false } }],
        },
      };

      this.renderChart(chartData, chartOptions);
    },
  },
  watch: {
    reasonsData: {
      immediate: true,
      handler() {
        if (this.reasonsData && this.reasonsData.length > 0) {
          this.updateChart();
        }
      },
    },
  },
  mounted() {
    this.updateChart();
  },
};
</script>


<style scoped>
.bar-chart-scroll {
  overflow-x: auto;
  width: 100%;
}

.bar-chart-container {
  position: relative;
  height: 300px;
  min-width: 900px;
}
</style>
